export const CHART_LEGENDS_ICON = {
  sleepTime: "/icons/star.webp",
  toiletTime: "/icons/moonDark.webp",
  waterDot: "/icons/dot_water.PNG",
  waterDotBluer: "/icons/dot_water1.PNG",
  wakeUpTime: "/icons/wakeuptime.webp",
  waterBluer: "/icons/blueWater1.webp",
  water: "/icons/blueWater.webp",
};

export const CHART_LEGENDS = [
  { title: "graph.sleepTime", icon: CHART_LEGENDS_ICON.sleepTime },
  { title: "graph.toiletTime", icon: CHART_LEGENDS_ICON.toiletTime },
  { title: "graph.waterDot", icon: CHART_LEGENDS_ICON.waterDot },
  { title: "graph.waterDotBluer", icon: CHART_LEGENDS_ICON.waterDotBluer },
  { title: "graph.wakeUpTime", icon: CHART_LEGENDS_ICON.wakeUpTime },
  { title: "graph.waterBluer", icon: CHART_LEGENDS_ICON.waterBluer },
  { title: "graph.water", icon: CHART_LEGENDS_ICON.water },
];

export const BEDWETTING_TYPE_VALUE = {
  the_alarm_went_off_and_I_woke_up_to_stop_it: {
    value: 1,
    title: "graph.calendarPage.waterBluer",
  },
  the_alarm_went_off_but_I_couldnt_wake_up_by_myself: {
    value: 2,
    title: "graph.calendarPage.water",
  },
  no_bedwetting_until_morning: {
    value: 3,
    title: "",
  },
};

export const BEDWETTING_TYPE_VALUE_MAPPING = {
  1: "the_alarm_went_off_and_I_woke_up_to_stop_it",
  2: "the_alarm_went_off_but_I_couldnt_wake_up_by_myself",
  3: "no_bedwetting_until_morning",
};

export const MEMO_TYPE = {
  1: "graph.calendarPage.notToilet",
  2: "graph.calendarPage.toiletMiddleNight",
};

export const TYPE_DATE_OPTIONS_VALUE = {
  day: 1,
  week: 2,
  month: 3,
};

export const TYPE_DATE_OPTIONS = [
  {
    label: "日",
    value: TYPE_DATE_OPTIONS_VALUE.day,
  },
  {
    label: "週",
    value: TYPE_DATE_OPTIONS_VALUE.week,
  },
  {
    label: "月",
    value: TYPE_DATE_OPTIONS_VALUE.month,
  },
];
